import Vue from "vue"
import Router from "vue-router"
import store from "@/vuex/store"
import {RoleEnum, ALL, DPD_AND_ADMIN, WORKFLOW_GROUP, GDPR_ADMIN_GROUP} from "@/model/enum/role-enum"

Vue.use(Router)

const routeList = [
  // home
  {
    path: "/",
    component: () => import("@/pages/home/Home.vue"),
    meta: {
      allowedRoles: ALL,
      icon: "fa-home",
      key: "home"
    }
  },
  // parcels
  {
    path: "/parcels/",
    component: () => import("@/pages/parcels/ParcelRoot.vue"),
    meta: {
      allowedRoles: ALL,
      icon: "fa-boxes",
      key: "parcels"
    },
    children: [
      {
        path: "/new_parcel",
        component: () => import("@/pages/parcels/new-parcel/NewParcel.vue"),
        meta: {
          allowedRoles: WORKFLOW_GROUP,
          icon: "fa-plus-circle",
          key: "new_parcel"
        }
      },
      {
        path: "/list_parcels",
        component: () => import("@/pages/parcels/parcel-list/ParcelList.vue"),
        meta: {
          allowedRoles: ALL,
          icon: "fa-list",
          key: "list_parcels"
        }
      },
      {
        path: "/new_parcel_upload",
        component: () => import("@/pages/parcels/parcel-upload/ParcelUpload.vue"),
        meta: {
          allowedRoles: WORKFLOW_GROUP,
          icon: "fa-upload",
          key: "new_parcel_upload"
        }
      },
      {
        path: "/reprint_self_booking_lists",
        component: () => import("@/pages/parcels/reprint-self-booking-lists/ReprintSelfBookingLists.vue"),
        meta: {
          allowedRoles: ALL,
          icon: "fa-print",
          key: "reprint_self_booking_lists"
        }
      }
    ]
  },
  // carorders
  {
    path: "/carorder/",
    component: () => import("@/pages/carorder/Carorder.vue"),
    meta: {
      allowedRoles: ALL,
      icon: "fa-car",
      key: "carorder"
    },
    children: [
      {
        path: "/new_carorder",
        component: () => import("@/pages/carorder/new-carorder/NewCarorder.vue"),
        // component: () => import("@/pages/wip/WorkInProgress.vue"),
        meta: {
          allowedRoles: WORKFLOW_GROUP,
          icon: "fa-plus-circle",
          key: "new_carorder"
        }
      },
      {
        path: "/list_carorder",
        component: () => import("@/pages/carorder/list-carorders/ListCarorders.vue"),
        // component: () => import("@/pages/wip/WorkInProgress.vue"),
        meta: {
          allowedRoles: ALL,
          icon: "fa-plus-circle",
          key: "list_carorders"
        }
      }
      // {
      //   path: "/import_carorders",
      //   component: () => import("@/pages/carorder/import-carorders/ImportCarorders.vue"),
      //   // component: () => import("@/pages/wip/WorkInProgress.vue"),
      //   meta: {
      //     allowedRoles: ALL,
      //     icon: "fa-plus-circle",
      //     key: "import_carorders"
      //   }
      // }
    ]
  },

  // collection request
  {
    path: "/collection_request/",
    component: () => import("@/pages/collection-request/CollectionRequest.vue"),
    meta: {
      allowedRoles: ALL,
      icon: "fa-clipboard-list",
      key: "collection_request"
    },
    children: [
      {
        path: "/new_collection_request",
        component: () => import("@/pages/collection-request/new-collection-request/NewCollectionRequest.vue"),
        // component: () => import("@/pages/wip/WorkInProgress.vue"),
        meta: {
          allowedRoles: WORKFLOW_GROUP,
          icon: "fa-plus-circle",
          key: "new_collection_request"
        }
      },
      {
        path: "/list_collection_request",
        component: () => import("@/pages/collection-request/list-collection-requests/ListCollectionRequests.vue"),
        // component: () => import("@/pages/wip/WorkInProgress.vue"),
        meta: {
          allowedRoles: ALL,
          icon: "fa-list",
          key: "list_collection_request"
        }
      },
      {
        path: "/collection_request_import",
        component: () => import("@/pages/collection-request/collection-request-import/CollectionRequestImport.vue"),
        // component: () => import("@/pages/wip/WorkInProgress.vue"),
        meta: {
          allowedRoles: WORKFLOW_GROUP,
          icon: "fa-upload",
          key: "collection_request_import"
        }
      }
    ]
  },
  // addresses
  {
    path: "/addresses",
    component: () => import("@/pages/addresses/Addresses.vue"),
    meta: {
      allowedRoles: ALL,
      icon: "fa-address-book",
      key: "addresses"
    },
    children: [
      {
        path: "/new_address",
        component: () => import("@/pages/addresses/new-address/NewAddress.vue"),
        meta: {
          allowedRoles: ALL,
          icon: "fa-plus-circle",
          key: "new_address"
        }
      },
      {
        path: "/list_addresses",
        component: () => import("@/pages/addresses/list-addresses/ListAddresses.vue"),
        meta: {
          allowedRoles: ALL,
          icon: "fa-plus-circle",
          key: "list_addresses"
        }
      },
      {
        path: "/address_import",
        component: () => import("@/pages/addresses/address-import/AddressUpload.vue"),
        meta: {
          allowedRoles: ALL,
          icon: "fa-address-book",
          key: "address_import"
        }
      }
    ]
  },
  // administration
  {
    path: "/administration/",
    component: () => import("@/pages/administration/Administration.vue"),
    meta: {
      allowedRoles: DPD_AND_ADMIN,
      icon: "fa-user-tie",
      key: "administration"
    },
    children: [
      {
        path: "/range",
        component: () => import("@/pages/administration/range/MasterRange.vue"),
        meta: {
          allowedRoles: DPD_AND_ADMIN,
          icon: "fa fa-product-hunt",
          key: "master_range"
        }
      },
      {
        path: "/products_editor",
        component: () => import("@/pages/administration/products-editor/ProductsEditor.vue"),
        meta: {
          allowedRoles: [RoleEnum.ADMIN],
          icon: "fa fa-product-hunt",
          key: "products_editor"
        }
      },
      {
        path: "/user_administration",
        component: () => import("@/pages/administration/user-administration/UserAdministration.vue"),
        meta: {
          allowedRoles: DPD_AND_ADMIN,
          icon: "fa-user-friends",
          key: "user_administration"
        }
      },
      {
        path: "/record_news",
        component: () => import("@/pages/administration/news-editor/RecordNews.vue"),
        meta: {
          allowedRoles: DPD_AND_ADMIN,
          icon: "fa-newspaper",
          key: "record_news"
        }
      },
      {
        path: "/parcel_shops",
        component: () => import("@/pages/administration/parcel-shop/ParcelShops.vue"),
        meta: {
          allowedRoles: DPD_AND_ADMIN,
          icon: "fa-shopping-cart",
          key: "parcel_shops"
        }
      },
      {
        path: "/language_editor",
        component: () => import("@/pages/administration/language-editor/LanguageEditor.vue"),
        meta: {
          allowedRoles: DPD_AND_ADMIN,
          icon: "fa-language",
          key: "language_editor"
        }
      },
      {
        path: "/company_ranges",
        component: () => import("@/pages/administration/company-ranges/CompanyRanges.vue"),
        meta: {
          allowedRoles: DPD_AND_ADMIN,
          icon: "fa-retweet",
          key: "company_ranges"
        }
      },
      {
        path: "/language_import",
        component: () => import("@/pages/administration/language-editor/LanguageImport.vue"),
        meta: {
          excludeFromNavbar: true,
          allowedRoles: ALL,
          icon: "fa-language-import",
          key: "language_import"
        }
      },
      {
        path: "/edit_product",
        component: () => import("@/pages/administration/products-editor/EditProduct.vue"),
        meta: {
          allowedRoles: [RoleEnum.ADMIN],
          excludeFromNavbar: true,
          icon: "fa fa-product-hunt",
          key: "edit_product"
        }
      },
      {
        path: "/news_editor/:id",
        component: () => import("@/pages/administration/news-editor/NewsEditor.vue"),
        meta: {
          allowedRoles: DPD_AND_ADMIN,
          excludeFromNavbar: true,
          icon: "fa fa-newspaper-o",
          key: "user_administration"
        }
      },
      {
        path: "/news_editor",
        component: () => import("@/pages/administration/news-editor/NewsEditor.vue"),
        meta: {
          allowedRoles: DPD_AND_ADMIN,
          excludeFromNavbar: true,
          icon: "fa fa-newspaper-o",
          key: "user_administration"
        }
      },
      {
        path: "/postal_codes",
        component: () => import("@/pages/administration/postal-codes/PostalCodes.vue"),
        meta: {
          allowedRoles: DPD_AND_ADMIN,
          icon: "fa-retweet",
          key: "postal_codes"
        }
      },
      {
        path: "/cut_off_time",
        component: () => import("@/pages/administration/cut-off-time/CutOffTime.vue"),
        meta: {
          allowedRoles: DPD_AND_ADMIN,
          icon: "fa-clock",
          key: "cut_off_time"
        }
      }
      // {
      //   path: "/shipnotify_log",
      //   component: () => import("@/pages/administration/shipnotify/Shipnotify.vue"),
      //   meta: {
      //     allowedRoles: [RoleEnum.ADMIN],
      //     icon: "fa-list-ol",
      //     key: "shipnotify"
      //   }
      // }
    ]
  },
  {
    path: "/administration/activity-history",
    component: () => import("@/pages/administration/activity-history/ActivityHistory.vue"),
    meta: {
      allowedRoles: GDPR_ADMIN_GROUP,
      icon: "fa fa-history",
      key: "activity-history"
    }
  },
  // login
  {
    path: "/login",
    component: () => import("@/pages/login/Login.vue"),
    meta: {
      excludeFromNavbar: true
    }
  },
  // New password
  {
    path: "/new_password",
    component: () => import("@/pages/new-password/NewPassword.vue"),
    meta: {
      excludeFromNavbar: true
    }
  },
  // no page
  {
    path: "/no_page",
    component: () => import("@/layout/no-page/NoPage.vue"),
    meta: {
      excludeFromNavbar: true
    }
  },
  // unauthorized
  {
    path: "/unauthorized",
    component: () => import("@/pages/unauthorized/Unauthorized.vue"),
    meta: {
      excludeFromNavbar: true
    }
  },
  // no page
  {
    path: "*",
    redirect: "/no_page",
    meta: {
      excludeFromNavbar: true
    }
  }
]

const router = new Router({
  mode: "history",
  routes: routeList
})

router.beforeEach((to, from, next) => {
  if ((to.path === "/login" || to.path === "/new_password")  && !store.getters.isAuthenticated) {
    next()
  } else if (to.path === "/login" || to.path === "/new_password" && store.getters.isAuthenticated) {
    next({
      path: "/"
    })
  } else if (!store.getters.isAuthenticated) {
    next({
      path: "/login",
      query: {redirect: to.fullPath}
    })
  } else if (to.meta.allowedRoles && !store.getters.employeeHasRequiredRole(to.meta.allowedRoles)) {
    next({
      path: "/unauthorized",
      query: {redirect: to.fullPath}
    })
  } else {
    next()
  }
})

export default router

export const routes = routeList
